/* SPACES collection: multi-select category filter + numbered pagination, client side from catalog-index.json */
(function () {
  // category labels [hu, en, ro]; categories come from catalog-index.json, anything not listed is shown as is
  var TR = {
    'Absztrakt': ['Absztrakt', 'Abstract', 'Abstract'], 'Állatok': ['Állatok', 'Animals', 'Animale'], 'Autók': ['Autók', 'Cars', 'Mașini'],
    'Bauhaus': ['Bauhaus', 'Bauhaus', 'Bauhaus'], 'Botanika': ['Botanika', 'Botanical', 'Botanică'], 'Gyerekszoba': ['Gyerekszoba', 'Nursery', 'Camera copiilor'],
    'Minimalista': ['Minimalista', 'Minimalist', 'Minimalist'], 'Művészet': ['Művészet', 'Art', 'Artă'], 'Portré': ['Portré', 'Portraits', 'Portrete'],
    'Pontillizmus': ['Pontillizmus', 'Pointillism', 'Pointilism'], 'Romantika': ['Romantika', 'Romance', 'Romantism'], 'Sötét hangulat': ['Sötét hangulat', 'Dark mood', 'Atmosferă întunecată'],
    'Szöveges': ['Szöveges', 'Typography', 'Text'], 'Tájkép': ['Tájkép', 'Landscapes', 'Peisaje'], 'Űr': ['Űr', 'Space', 'Spațiu'],
    'Városok': ['Városok', 'Cities', 'Orașe'], 'Vintage plakátok': ['Vintage plakátok', 'Vintage posters', 'Afișe vintage'],
    'Márvány': ['Márvány', 'Marble', 'Marmură'], '3D': ['3D', '3D', '3D'], 'Arabeszk': ['Arabeszk', 'Arabesque', 'Arabesc'], 'Tégla': ['Tégla', 'Brick', 'Cărămidă'],
    'Étterem': ['Étterem', 'Restaurant', 'Restaurant'], 'Virágos': ['Virágos', 'Floral', 'Floral'], 'Geometrikus': ['Geometrikus', 'Geometric', 'Geometric'],
    'Arany': ['Arany', 'Gold', 'Auriu'], 'Fém': ['Fém', 'Metal', 'Metal'], 'Kő': ['Kő', 'Stone', 'Piatră'], 'Csíkos': ['Csíkos', 'Striped', 'Dungi'],
    'Textúra': ['Textúra', 'Texture', 'Textură'], 'Városi': ['Városi', 'Urban', 'Urban'], 'Fa': ['Fa', 'Wood', 'Lemn']
  };
  var CDN = 'https://cdn.shopify.com/s/files/1/0944/5402/2483/files/';
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function init() {
    var root = document.querySelector('[data-flt]');
    if (!root || root.__f) return;
    root.__f = 1;
    var D = root.dataset, line = D.line, lang = (document.documentElement.lang || 'hu').slice(0, 2), li = lang === 'en' ? 1 : lang === 'ro' ? 2 : 0;
    var per = 24, sel = [], page = 1, items = [];
    var bar = root.querySelector('[data-chips]'), cnt = root.querySelector('[data-count]'), grid = document.querySelector('[data-grid]'), pager = document.querySelector('[data-pager]');
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var qs = new URLSearchParams(location.search);
    if (qs.get('c')) sel = qs.get('c').split(',').filter(Boolean);
    if (qs.get('p')) page = Math.max(1, parseInt(qs.get('p'), 10) || 1);
    fetch(D.index).then(function (r) { return r.json(); }).then(function (all) {
      items = all.filter(function (x) { return x.l === line; });
      render(true);
    }).catch(function () { });
    function filtered() { return sel.length ? items.filter(function (x) { return sel.indexOf(x.c) > -1; }) : items; }
    function price(x) {
      var p = String(Math.round(x.p)).replace(/\B(?=(\d{3})+(?!\d))/g,' ') + ' Ft';
      if (line === 'mural') return p + ' / m²';
      if (line === 'paper') return '9 900' + ' Ft / m²';
      return p + (D.tFrom || '');
    }
    function url() {
      var q = new URLSearchParams();
      if (sel.length) q.set('c', sel.join(','));
      if (page > 1) q.set('p', page);
      var s = q.toString();
      return location.pathname + (s ? '?' + s : '');
    }
    function chips() {
      var counts = {};
      items.forEach(function (x) { counts[x.c] = (counts[x.c] || 0) + 1; });
      var h = '<button type="button" class="sp-pill' + (sel.length ? '' : ' on') + '" data-all>' + esc(D.tAll) + '</button>';
      Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a] || a.localeCompare(b, 'hu'); }).forEach(function (k) {
        if (!k) return;
        var t = TR[k] || [k, k, k];
        h += '<button type="button" class="sp-pill' + (sel.indexOf(k) > -1 ? ' on' : '') + '" data-cat="' + esc(k) + '">' + esc(t[li]) + '</button>';
      });
      bar.innerHTML = h;
    }
    function cards(list) {
      return list.map(function (x) {
        var img = x.i ? '<img src="' + CDN + x.i + '?width=600" alt="' + esc(x.t[li]) + '" loading="lazy">' : '<div class="sp-ph"></div>';
        return '<div class="in"><a class="sp-card" href="' + rootUrl + 'products/' + x.h + '"><div class="sp-frame' + (line !== 'art' ? ' nat' : '') + '">' + img + '</div><div class="sp-meta"><span class="t">' + esc(x.t[li]) + '</span><span class="p">' + esc(price(x)) + '</span></div></a></div>';
      }).join('');
    }
    function pages(n) {
      if (n <= 1) return '';
      var s = [], i;
      for (i = 1; i <= n; i++) { if (i === 1 || i === n || Math.abs(i - page) <= 1) s.push(i); else if (s[s.length - 1] !== '…') s.push('…'); }
      var h = '<button type="button" class="pg" data-pg="' + (page - 1) + '"' + (page === 1 ? ' disabled' : '') + ' aria-label="' + esc(D.tPrev) + '">&larr;</button>';
      s.forEach(function (p) { h += p === '…' ? '<span class="dots">…</span>' : '<button type="button" class="pg' + (p === page ? ' on' : '') + '" data-pg="' + p + '"' + (p === page ? ' aria-current="page"' : '') + '>' + p + '</button>'; });
      return h + '<button type="button" class="pg" data-pg="' + (page + 1) + '"' + (page === n ? ' disabled' : '') + ' aria-label="' + esc(D.tNext) + '">&rarr;</button>';
    }
    function render(first) {
      var f = filtered(), n = Math.max(1, Math.ceil(f.length / per));
      if (page > n) page = n;
      chips();
      cnt.textContent = f.length + ' ' + D.tRes + (sel.length ? ' · ' : '');
      if (sel.length) { var b = document.createElement('button'); b.type = 'button'; b.className = 'sp-flt-clear'; b.dataset.clear = '1'; b.textContent = D.tClear; cnt.appendChild(b); }
      grid.innerHTML = f.length ? cards(f.slice((page - 1) * per, page * per)) : '<p class="sp-h3">' + esc(D.tNone) + '</p>';
      pager.innerHTML = pages(n);
      if (!first) history.replaceState(null, '', url());
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-all') || b.dataset.clear) { sel = []; }
      else if (b.dataset.cat) { var i = sel.indexOf(b.dataset.cat); if (i > -1) sel.splice(i, 1); else sel.push(b.dataset.cat); }
      else return;
      page = 1; render();
    });
    pager.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-pg]'); if (!b || b.disabled) return;
      page = parseInt(b.dataset.pg, 10); render();
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
